import React from "react";
import { tierListColor } from "../TierLists/TierListHelper";
import MediaQuery from "components/MediaQuery";
import { TooltipContainer } from "@outplayed/tooltips";
import { ReactComponent as TooltipIcon } from "svg/question-line.svg";
import { capitalizeFirstLetter } from "../../../lib/general-helper";

const PvPStatSection = ({ pvpData }) => {
  const allianceStat = pvpData?.stats?.factions?.filter((obj) => obj.faction === "alliance")[0];
  const hordeStat = pvpData?.stats?.factions?.filter((obj) => obj.faction === "horde")[0];
  const topThreeRaces = pvpData?.stats?.races?.sort((a, b) => b.popularity - a.popularity).slice(0, 3);
  const tier = pvpData?.stats?.tier ?? "";

  return (
    <div className="pvp-stat-section-container">
      <div className="left-sections">
        <div className="text-section">
          <div className="value" style={{ color: tierListColor(tier) }}>
            {tier}
          </div>
          <div className="label">
            Tier
            <TooltipContainer tooltipInfo="Each spec's tier is determined by using a combination of both its win rate and the popularity among the top players on each PvP leaderboard">
              <div className="tooltip-container">
                <TooltipIcon className="tooltip-icon" />
              </div>
            </TooltipContainer>
          </div>
        </div>
        <MediaQuery min="MOBILE_LARGE" max="DESKTOP_LARGE" renderNullOnFail>
          <div className="stat-border" />
        </MediaQuery>
        <div className="text-section">
          <div className="value">{pvpData?.stats?.rating}</div>
          <div className="label">
            Median Rating
            <TooltipContainer tooltipInfo="The median rating of the selected spec out of all players we're analyzing">
              <div className="tooltip-container">
                <TooltipIcon className="tooltip-icon" />
              </div>
            </TooltipContainer>
          </div>
        </div>
      </div>
      <div className="stat-border" />
      <div className="right-sections">
        <div className="image-section">
          <div className="label">Top Races</div>
          <div className="images-container">
            {topThreeRaces?.map((race, index) => (
              <TooltipContainer tooltipInfo={capitalizeFirstLetter(race.race)} key={index}>
                <img src={`https://static.bigbrain.gg/wow/races/${race.race}.webp`} alt={race.race} />
              </TooltipContainer>
            ))}
          </div>
          <div className="values-container">
            {topThreeRaces?.map((race, index) => (
              <div className="img-value" key={index}>
                {race.popularity + "%"}
              </div>
            ))}
          </div>
        </div>
        <MediaQuery min="MOBILE_LARGE" max="DESKTOP_LARGE" renderNullOnFail>
          <div className="stat-border" />
        </MediaQuery>
        <div className="image-section">
          <div className="label">Faction</div>
          <div className="images-container">
            <TooltipContainer tooltipInfo="Alliance">
              <img src="https://static.bigbrain.gg/wow/assets/alliance_icon.png" alt="Alliance" />
            </TooltipContainer>
            <TooltipContainer tooltipInfo="Horde">
              <img src="https://static.bigbrain.gg/wow/assets/horde_icon.png" alt="Horde" />
            </TooltipContainer>
          </div>
          <div className="values-container">
            <div className="img-value">{(allianceStat?.popularity ?? 0) + "%"}</div>
            <div className="img-value">{(hordeStat?.popularity ?? 0) + "%"}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PvPStatSection;
